<template>
    <div class="image">
      <svg  viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.0003 12.1667H12.667M9.33333 12.1667H1M1 3.8335H4.33333M7.66699 3.8335H16.0003M10.1663 9.66675H11.833C12.293 9.66675 12.6663 10.0401 12.6663 10.5001V13.8334C12.6663 14.2934 12.293 14.6667 11.833 14.6667H10.1663C9.70634 14.6667 9.33301 14.2934 9.33301 13.8334V10.5001C9.33301 10.0401 9.70634 9.66675 10.1663 9.66675ZM6.83301 6.3335H5.16634C4.70634 6.3335 4.33301 5.96016 4.33301 5.50016V2.16683C4.33301 1.70683 4.70634 1.3335 5.16634 1.3335H6.83301C7.29301 1.3335 7.66634 1.70683 7.66634 2.16683V5.50016C7.66634 5.96016 7.29301 6.3335 6.83301 6.3335Z" stroke="#9197B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </div>
</template>
  
  <script>
  
  
  export default {
    name: 'SettingIcon'
  }
  </script>

<style scoped>
  .image svg{
     width: 15px;
     height: 13.33px;
  }
</style>
  